module.exports = __webpack_public_path__ + "2e9cc622bc054401fc421a28c6c71d4a.woff";